/* ng-tooltip
 * modified by jinhun.shin
 * source :drozhzhin-n-e/ng2-tooltip-directive
 * https://github.com/drozhzhin-n-e/ng2-tooltip-directive
 *
 *  usage
 *
    *Name**                 | **Type**                         | **Description**
    :-----:                 | :-----:                          | :-----:
    placement               | "top", "bottom", "left", "right" | The position of the tooltip.
    show-delay              | number                           | The delay in ms before showing the tooltip.
    z-index                 | number                           | Z-index of the tooltip.
    tooltip-align           | "left", "right", "center"        | tooltip의 넒이가 지정되었을때 문장 정렬을 해줍니다.
    tooltip-width-condition |                                  | tooltip이 발생하는 엘리먼트에 말줄임이 설정되어 있을때만 툴팁을 발생시킵니다.
    tooltip-one-line        |                                  | 툴팁을 무조건 한줄로 만들어 출력시킵니다.
    tooltip-alert           | Boolean                          | 경고를 빨간색으로 출력할때
 */
import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[tooltip]'
})

export class TooltipDirective {
    tooltip: any;
    elemPosition: any;
    tooltipOffset = 8;
    showTimeoutId: number;

    @Input('title') title = '';
    @Input('tooltip') tooltipText = '';
    @Input() placement = 'bottom';              // 기본 포지션이 열리는 위치를 아래쪽으로 설정함
    @Input() delay = 0;
    @Input('show-delay') showDelay = 10;
    // @Input('hide-delay') hideDelay = 120;       // 툴팁이 사라질때 기본 딜레이
    @Input('z-index') zIndex = false;
    @Input('tooltip-align') align = 'left';
    @Input('tooltip-width-condition') isSetWidthCondition: Boolean;
    @Input('tooltip-one-line') isNoLineBreak: Boolean = false;       // 기본 넓이가 지정되면 기본 넓이값을 세팅함.
    @Input('tooltip-alert') isAlert;                   //사용자가

    @Input('tooltip-arrow-left') isArrowLeft;                   //사용자
    @Input('tooltip-arrow-left-perfect') isArrowLeftPerfect; // 완전히 독립적으로 왼쪽으로 툴팁이 나오도록 표시


    constructor(private elementRef: ElementRef) {}

    // @HostListener('focusin')
    @HostListener('mouseenter')
    // @HostListener('mousemove')
    onMouseEnter() {
        this.getElemPosition();

        if (!this.tooltip && this.isMarkTooltip()){
            this.create();
            this.setPosition();
            this.show();
        }
    }

    // @HostListener('focusout')
    @HostListener('mouseleave')
    // @HostListener ('mousedown')
    onMouseLeave() {
        this.hide();
    }

    getElemPosition() {
        this.elemPosition = this.elementRef.nativeElement.getBoundingClientRect();
    }

    isMarkTooltip () {
        // maxwidth와 element width의 값을 비교해서 element width가 커서 말줄임이 발생하면 툴팁을 띄워준다.

        if (typeof this.isSetWidthCondition === 'undefined') {
            return true;
        }

        const elem = this.elementRef.nativeElement;

        let _maxWidth: any;

        // 절대 넓이는 px과 % 두가지 연산자만 넣자..
        if (/\%/g.test(window.getComputedStyle(elem).getPropertyValue('max-width'))) {
            _maxWidth = (elem.parentNode.offsetWidth || elem.parentNode.clientWidth) / 100 * parseInt(window.getComputedStyle(elem).getPropertyValue('max-width'));
            // 소수점을 버려야 공정한 비교가...
            // 상위 엘리먼트에서 padding을 포함하지 않고 offsetWidth를 계산하는 폐단이 있구먼.
            _maxWidth = Math.floor(_maxWidth) - 20;
        } else {
            _maxWidth = parseInt(window.getComputedStyle(elem).getPropertyValue('max-width')) ;
        }


        const _elemWidth = elem.offsetWidth;

        // console.log(_maxWidth,_elemWidth);
        return (_maxWidth <= _elemWidth);
    }

    create() {
        this.showDelay = this.delay || this.showDelay;
        this.tooltip = document.createElement('span');
        this.tooltip.className += 'ng-tooltip ng-tooltip-' + this.placement + ' ' + 'ng-tooltip-align-' + this.align;
        this.tooltip.id = 'ngTooltipForAlert';

        if (typeof this.isAlert !== 'undefined') {
            this.tooltip.className += ' ' + 'ng-tooltip-alert';
        }

        if (typeof this.isArrowLeft !== 'undefined') {
            this.tooltip.className += ' ' + 'ng-tooltip-arrow-left';
        }

        if (typeof this.isArrowLeftPerfect !== 'undefined') {
            this.tooltip.className += ' ' + 'ng-tooltip-arrow-perfect';
        }

        // 최소 넓이가 있으면 최소 넓이를 넣어준다.
        if (this.isNoLineBreak !== false) {     // !!!! 이게 처음에 boolean으로 값을 설정하는 방법이 있을텐데 인스턴스가 없으면 말이지
            this.tooltip.style.whiteSpace = 'nowrap';
            this.tooltip.style.maxWidth = 'none';
        } else {
            // 일반적인 경우 개행 표시 (터미널로지에서 개행 필요함)
            this.tooltip.style.whiteSpace = 'pre-wrap';
        }

        // 기본적으로 title로 tooltip을 열도록 한다. tooltipText가 있으면 그걸 열어줌
        this.tooltip.textContent = this.title || this.tooltipText;

        if (this.zIndex) {
            this.tooltip.style.zIndex = this.zIndex;
        }

        // 툴팁이 겹치는 버그가 있어
        // console.log(this.tooltip);
        // if (!!document.getElementById('ngTooltipForAlert')) {
        //    document.getElementById('ngTooltipForAlert').outerHTML = '';
        // }

        document.body.appendChild(this.tooltip);
    }

    show() {
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
        }

        // native tooltip을 가리고 custom tooltip을 열어준다.
        // this.elementRef.nativeElement.title = this.isMarkTooltip() ? '' : this.title;

        this.showDelay = this.delay || this.showDelay;
        this.showTimeoutId = window.setTimeout(() => {
            if (this.tooltip) {
                this.tooltip.className += ' ng-tooltip-show';
            }
        }, this.showDelay);
    }

    hide() {
        clearTimeout(this.showTimeoutId);

        if (this.tooltip) {
            this.tooltip.classList.remove('ng-tooltip-show');
            this.tooltip = null;

            // 마우스 이벤트 반응이 브라우저마다 다르게 반응하므로, 남아있는 모든 엘리먼트를 삭제한다.
            const tooltipElement = document.querySelectorAll('.ng-tooltip');

            window.setTimeout(() => {
                for (let i = 0; i < tooltipElement.length; i++) {
                    try {
                        tooltipElement[i].outerHTML = '';
                    } catch (e) {

                    }
                }
            }, 1);
        }
    }

    _listener = () => {
        // 마우스 클릭 시 툴팁 닫음
        this.hide();
        window.removeEventListener('click', this._listener);
    };

    setPosition() {
        const elemHeight = this.elementRef.nativeElement.offsetHeight;
        const elemWidth = this.elementRef.nativeElement.offsetWidth;
        const tooltipHeight = this.tooltip.clientHeight;
        const tooltipWidth = this.tooltip.offsetWidth;
        const scrollX = (window.pageXOffset || document.documentElement.scrollLeft);
        const scrollY = window.pageYOffset;

        // 스크롤이 생성되면 툴팁 닫는다.
        // 스크롤 이벤트가 감지되면 툴팁 닫는다.
        window.addEventListener('scroll', () => {
            this.hide();
        });
        // 버튼 삭제 시 툴팁 남아 있는 현상 수정
        window.addEventListener('click', this._listener);

        if (this.placement === 'top') {
            this.tooltip.style.top = (this.elemPosition.top) - (tooltipHeight + this.tooltipOffset) + 'px';
        }

        if (this.placement === 'bottom') {
            this.tooltip.style.top = (this.elemPosition.top) + elemHeight + this.tooltipOffset + 'px';
        }

        if (this.placement === 'top' || this.placement === 'bottom') {
            this.tooltip.style.left = (this.elemPosition.left + elemWidth / 2) - tooltipWidth / 2  + 'px';
        }

        if (this.placement === 'left') {
            this.tooltip.style.left = this.elemPosition.left - tooltipWidth - this.tooltipOffset + 'px';
        }

        if (this.placement === 'right') {
            this.tooltip.style.left = this.elemPosition.left + elemWidth + this.tooltipOffset + 'px';
        }

        if (this.placement === 'left' || this.placement === 'right') {
            this.tooltip.style.top = (this.elemPosition.top + scrollY) + elemHeight / 2 - this.tooltip.clientHeight / 2 + 'px';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/tooltip/tooltip.directive.ts